var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4802_1239)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26.0009,
    cy: 23.9999,
    r: 21.8973,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1731 24.4459C37.1731 24.683 37.079 24.9103 36.9113 25.0779C36.7437 25.2455 36.5164 25.3397 36.2793 25.3397H27.3417V34.2774C27.3417 34.5144 27.2475 34.7418 27.0799 34.9094C26.9123 35.077 26.6849 35.1712 26.4479 35.1712C26.2108 35.1712 25.9835 35.077 25.8159 34.9094C25.6483 34.7418 25.5541 34.5144 25.5541 34.2774V25.3397H16.6164C16.3794 25.3397 16.152 25.2455 15.9844 25.0779C15.8168 24.9103 15.7227 24.683 15.7227 24.4459C15.7227 24.2089 15.8168 23.9816 15.9844 23.8139C16.152 23.6463 16.3794 23.5522 16.6164 23.5522H25.5541V14.6145C25.5541 14.3774 25.6483 14.1501 25.8159 13.9825C25.9835 13.8149 26.2108 13.7207 26.4479 13.7207C26.6849 13.7207 26.9123 13.8149 27.0799 13.9825C27.2475 14.1501 27.3417 14.3774 27.3417 14.6145V23.5522H36.2793C36.5164 23.5522 36.7437 23.6463 36.9113 23.8139C37.079 23.9816 37.1731 24.2089 37.1731 24.4459Z",
    fill: "#005298"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4802_1239",
    x: 0.103516,
    y: 0.102539,
    width: 51.7949,
    height: 51.7949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4802_1239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4802_1239",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMoney);
export default __webpack_public_path__ + "static/media/AddMoney.d60b78c7c3753442b6d2c525164ca95c.svg";
export { ForwardRef as ReactComponent };